<script setup lang="ts">
import type { RetailBlockType } from '~/interfaces/api';
import BannersCardPrice from '~/components/banners/BannersCardPrice.vue';

defineProps({
  index: {
    type: Number,
    default: 0,
  },
  model: {
    type: Object as any,
    required: true,
  },
  retailBlock: {
    type: Object as () => RetailBlockType | undefined,
    default: undefined,
  },
  currentCategory: {
    type: String || null,
    default: null,
  },
});
</script>

<template>
  <template v-if="model.type === 'retail' && retailBlock">
    <BannersCardRetailListingBlock :retail-block="retailBlock" />
  </template>
  <template v-else-if="model.type === 'price-banner'">
    <BannersCardPrice
      :banner="model.block"
      :current-category="currentCategory"
    />
  </template>
  <template v-else>
    <div class="cat" />
  </template>
</template>

<style scoped lang="scss"></style>
